<script>
import { mapState } from "pinia";

import { LayoutTypes } from "@/services/context/layout-helper";
import Popin from "@/components/molecules/popin";
import { useContextStore } from "@/store/context";

export default {
  components: {
    Popin
  },
  props: {
    page: {
      type: Boolean,
      required: false,
      default: false
    },
    pageBack: {
      type: Boolean,
      required: false,
      default: false
    },
    class: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapState(useContextStore, ["layout"]),
    isMobile() {
      return this.layout === LayoutTypes.mobile;
    }
  },
  methods: {
    show() {
      this.$refs.popin.show();
    },
    hide() {
      this.$refs.popin.hide();
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    :class="class"
    :slide-up="isMobile && !page"
    :page="isMobile && page"
    :page-back="isMobile && pageBack"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
  >
    <slot />
  </Popin>
</template>
